export default {
  title: 'Viimeiset 4 viikkoa',
  item_interval: '(1)[Käynyt 1 kerran];(2)[Käynyt 2 kertaa];(3-5)[Käynyt 3-5 kertaa];(6-inf)[Käynyt 6+ kertaa];',
  total: 'Kävijöitä yhteensä',
};
